import {Company} from '@legit.health/ui';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBook from '@mui/icons-material/MenuBook';
import PaymentIcon from '@mui/icons-material/Payment';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {Condition} from '@/patient/interfaces/Condition';
import Patient from '@/patient/interfaces/Patient';
import patientPaths from '@/patient/routing/paths';
import EncountersIcon from '@/shared/components/ui/icons/EncountersIcon';
import EvolutionIcon from '@/shared/components/ui/icons/EvolutionIcon';
import sharedPaths, {USER_HOME} from '@/shared/routing/paths';

const menuItems = (patient: Patient, company: Company, conditions: Condition[]) => {
  const isFullBody =
    company.clinicalTrial &&
    company.clinicalTrial.definition?.pathologies?.length > 0 &&
    company.clinicalTrial.definition.pathologies.some((p) => p.bodySite === '');

  if (company.isForClinicalTrials) {
    return [
      {
        name: 'patient/common:menu.diagnosticReports',
        link: isFullBody ? patientPaths.GLOBAL_DIAGNOSTIC_REPORTS : patientPaths.DIAGNOSTIC_REPORTS,
        icon: <EvolutionIcon />,
        id: 'menuEvolution'
      },
      {
        name: 'patient/common:menu.dashboard',
        link: USER_HOME,
        icon: <DashboardIcon />,
        id: 'menuPanel'
      }
    ];
  }

  return [
    ...(patient.isAllowedToUploadPhotos
      ? [
          {
            name: 'patient/common:menu.encounters',
            link: patientPaths.PATIENT_ENCOUNTER_LIST,
            icon: <EncountersIcon />,
            id: 'menuEncounters'
          }
        ]
      : []),
    {
      name: 'patient/common:menu.diagnosticReports',
      link: patientPaths.DIAGNOSTIC_REPORTS,
      icon: <EvolutionIcon />,
      id: 'menuEvolution'
    },
    {
      name: 'patient/common:menu.documents',
      link: patientPaths.DOCUMENT_LIST,
      icon: <UploadFileIcon />,
      id: 'uploadDocument'
    },
    {
      name: 'shared/medicationRequest:medicationRequests',
      link: sharedPaths.MEDICATION_REQUEST_LIST,
      icon: <AssignmentIcon />,
      id: 'uploadDocument'
    },
    ...(company.stripeConnect.isPatientPaymentOrdersEnabled
      ? [
          {
            name: 'patient/common:menu.payment',
            link: patientPaths.PAYMENT_ORDER_LIST,
            icon: <PaymentIcon />,
            id: 'menuPayment'
          }
        ]
      : []),
    {
      name: 'patient/common:menu.dashboard',
      link: USER_HOME,
      icon: <DashboardIcon />,
      id: 'menuPanel'
    },
    ...(conditions.find((c) => c.pathology.code === 'Psoriasis')
      ? [
          {
            name: 'patient/common:menu.psoriasis',
            link: patientPaths.PSORIASIS_INFO,
            icon: <MenuBook />,
            id: 'menuPsoriasis'
          }
        ]
      : [])
  ];
};

export default menuItems;
